import { datumZeitDe } from './format';

/**
 * Die Kennung des ausgelieferten Standes (A29).
 *
 * Der Wert kommt aus `define` in vite.config.ts und steckt damit im
 * Bundle selbst — nicht in einer Datei daneben, die mit ihm
 * auseinanderlaufen könnte.
 *
 * Der `typeof`-Wächter ist kein Zierrat: Wer diese Datei aus einem
 * Werkzeug heraus lädt, das die Konstante nicht definiert, bekäme sonst
 * einen ReferenceError statt einer Auskunft. Auch hier gilt, was für den
 * Bau gilt — lieber „unbekannt" als ein Fehler.
 */
export type BuildKennung = {
  hash: string;
  gebautAm: string;
  schmutzig: boolean;
};

const UNBEKANNT: BuildKennung = { hash: 'unbekannt', gebautAm: '', schmutzig: false };

export const BUILD_KENNUNG: BuildKennung =
  typeof __BUILD_KENNUNG__ === 'undefined' ? UNBEKANNT : __BUILD_KENNUNG__;

/**
 * Die Kennung als Zeile, wie sie jemand in eine Fehlermeldung tippt.
 *
 * Bewusst eine reine Funktion neben der Anzeige: So lassen sich alle
 * drei Fälle prüfen, ohne einen Bau anzuwerfen.
 *
 * Der schmutzige Fall wird ausdrücklich benannt und nicht nur farblich
 * angedeutet. „Mit lokalen Änderungen gebaut" heißt: der Hash daneben
 * beschreibt NICHT, was ausgeliefert wurde — und wer das nicht liest,
 * sucht den Fehler im falschen Commit.
 */
export function kennungText(k: BuildKennung = BUILD_KENNUNG): string {
  if (k.hash === 'unbekannt') {
    return k.gebautAm === ''
      ? 'Stand unbekannt'
      : `Stand unbekannt · gebaut ${datumZeitDe(k.gebautAm)}`;
  }
  const teile = [`Stand ${k.hash}`, `gebaut ${datumZeitDe(k.gebautAm)}`];
  if (k.schmutzig) {
    teile.push('mit lokalen Änderungen gebaut');
  }
  return teile.join(' · ');
}
